export default {
  columns: {
    title: 'Titel',
    image: 'Billede',
    button_url: 'Knap-URL',
    button_text: 'Knaptekst',
    description: 'Beskrivelse',
    visible: 'Synlig',
    actions: 'Handlinger',
  },
  buttons: {
    create_post: 'Opret opslag',
    edit: 'Rediger',
    delete: 'Slet',
    cancel: 'Annuller',
    confirm: 'Bekræft',
  },
  title: 'Fremhævede opslag',
  delete_confirmation: 'Er du sikker på, at du vil slette dette opslag?',
};
